const blockStyleFn = (block: Record<string, any>): string => {
  const blockAlignment = block.getData() && block.getData().get('text-align')

  if (blockAlignment) {
    return `rte-${blockAlignment}-aligned-block`
  }

  return ''
}

export default blockStyleFn
